import React from 'react';

const useChangeEffect = (effect: React.EffectCallback, deps?: React.DependencyList) => {
  const mounted = React.useRef(false);

  React.useEffect(() => {
    let callback: void | (() => void | undefined);

    if (!mounted.current) {
      callback = effect();
    }

    mounted.current = true;

    return () => {
      mounted.current = false;
      callback?.();
    };
  }, deps);
};

export default useChangeEffect;
